import AnnotationChangePreview from "./AnnotationChangePreview";
import RotationContainerSvg from "./RotationContainerSvg";
import CroppableImage from "./CroppableImage";
import O from "./O";
import { useMemo, useState, createContext, useCallback } from 'react';

import { useDispatch, useStore } from 'react-redux';
import A from './ActionCreators';
import G from './Getters';
import { CropAdjustmentDispatch, VerticalTranslationContext, CropAdjustmentContext } from './Contexts';
import { add, scale, vectorAngleRad, minus, rotatePoint, distance } from './Geometry';

import { computeFromVertBottom, computeFromVertTop, computeFromHorizAdj, getUpdatedLsFromInlineCrop } from './CropResizeFunctions';


const defaultT = { 
  untilRowIndex:2,
  y:50,
}
const FUNC_MAP = {
  left:getCropFromRotation,
  right:getCropFromRotation,
  bottom:computeFromVertBottom,
  top:computeFromVertTop
}

function getCropFromRotation(start,end,{inlineCrop,cellWidthOfCropBeingAdjusted,side,annotationId,store}){


  let {ls,height} = G.getAnnotation(store.getState(),annotationId);
  
  let angleToRotate = vectorAngleRad(ls);

  let deltaV_figureScale = minus(start,end);
  
  let scaleFactor = cellWidthOfCropBeingAdjusted / inlineCrop.width;
  let scaleDown = 1/scaleFactor;

  let deltaV_prop = scale(scaleDown,deltaV_figureScale);
  let deltaV_prop_imageAxis = rotatePoint(deltaV_prop,angleToRotate);

  let fromLeft = side.includes("left") ? 1 : 0;
  let fromRight = fromLeft ? 0 : 1;

  
  let [p0,p1] = ls;
  let newP0 = add(p0, fromLeft ? deltaV_prop_imageAxis : [0,0]);
  let newP1 = add(p1, fromRight ? deltaV_prop_imageAxis : [0,0]);

  let newLs = [
    newP0,
    newP1,
  ]



  let cropRatio = inlineCrop.width / inlineCrop.height;
  let newHeight = distance(newLs) / cropRatio;

  let newInlineCrop =  G.getCropFromAnnotation(store.getState(),annotationId,{ls:newLs});

  return { ls:newLs, crop:{...newInlineCrop,height:newHeight}, height:newHeight };

}

function getVerticalResizeTransformation(start,end,info){

  let { cellLocation, side } = info;
  let deltaY = end[1] - start[1];

    const vertResizeTranslateMap = {
      top:{
        untilRowIndex:cellLocation[0],
        y:deltaY
      },
      bottom:{
        untilRowIndex:0,
        y:0
      }
    }

  let vTrans = vertResizeTranslateMap[side];
  return vTrans;
}



export default function CropAdjustmentProvider({children}){

  const [ cropResizeInfo, _setCropResizeInfo ] = useState(); 
  const [ verticalImageResizeTranslation, setVerticalImageResizeTranslation ] = useState({ untilRowIndex:-1, y:0 })

  function setCropResizeInfo(info){
    if( !info ){
    }
    _setCropResizeInfo(info);
  }


  let dispatch = useDispatch();
  const store = useStore();

  const onMouseMove = useCallback((start,end,info) => {

    let { side, annotationId } = info;
    let props = {...info,store};
    if( !side ){
      debugger;
    }
    let resizeInfo = FUNC_MAP[side](start,end,props);
    if( !resizeInfo ){
      debugger;
    }

    let { ls, height, crop } = resizeInfo;

    let annotation = G.getAnnotation(store.getState(),annotationId);
    
    let atnUpdate = getUpdatedLsFromInlineCrop(start,end,{...info,annotation},crop)
    if( ls ){
      atnUpdate.ls = ls;
      crop.height = height;
    }

    let newCropResizeInfo = {
      ...info,
      ...cropResizeInfo,
      inlineCrop:crop,
      value:{ annotationId },
      tempInlineCrop:crop,
      atn:atnUpdate
    }

    setCropResizeInfo(newCropResizeInfo)
  
    if( !side.includes('rotate') ){
      let vTrans = getVerticalResizeTransformation(start,end,info); 
      vTrans && setVerticalImageResizeTranslation(vTrans);
    }
    
  },[setVerticalImageResizeTranslation]);


  const onDragEnd = useCallback((start,end,info) => {

    let { side, annotationId } = info;
    let props = {...info,store};
     let { ls, height, crop } = FUNC_MAP[side](start,end,props);

    let annotation = G.getAnnotation(store.getState(),annotationId);
    
    let atnUpdate = getUpdatedLsFromInlineCrop(start,end,{...info,annotation},crop)
    
    if( ls ){
      //this ensures constant crop ratio.
      atnUpdate.ls = ls;
    }

    let newCropResizeInfo = {
      ...info,
      ...cropResizeInfo,
      inlineCrop:crop,
      value:{ annotationId },
      tempInlineCrop:crop,
      atn:atnUpdate
    }

    setVerticalImageResizeTranslation({
      untilRowIndex:-1,
      y:0
    })

    dispatch(A.setAnnotationProperties({
      _id:annotation._id,
      ...atnUpdate,
    })) 

    info?.toNullify?.forEach(setterToNullify => {
      setterToNullify(null);
    })


  },[store,dispatch])

  window.__onDragEnd = onDragEnd;


  const dispatchValue = useMemo(() => ({
    setCropResizeInfo,
    onMouseMove,
    onDragEnd,
  }),[])
 

  return (
    <CropAdjustmentDispatch.Provider value={dispatchValue}>
      <VerticalTranslationContext.Provider value={verticalImageResizeTranslation}>
        <CropAdjustmentContext.Provider value={cropResizeInfo}>
          {children}




          {false && cropResizeInfo && <AnnotationChangePreview {...{
            cropResizeInfo
          }}/>}

          
        </CropAdjustmentContext.Provider>

      </VerticalTranslationContext.Provider>

    </CropAdjustmentDispatch.Provider>

  )


}
